module.exports = __webpack_public_path__ + "static/media/E_SDG_Icons-04.cb620838.jpg";